import { BACKGROUND_IMAGE_DESKTOP, BACKGROUND_IMAGE_MOBILE } from '../elements/assets'

export const TEXT_BANNER = `
...on textBanner_Entry {
  id
  typeHandle

  text {
    html
  }
  ${ BACKGROUND_IMAGE_DESKTOP }
  ${ BACKGROUND_IMAGE_MOBILE }
}
`